import Quiz from '../scripts/QuizClass'
const $functions = require('../scripts/functions');
import BaseExercise from '../BaseExercise/BaseExercise.vue';
export default {
	name: 'CreateQuiz',
	props: {
		quizProp: {type: Object, default: () => ({})},
		processing: { type: Boolean, default: false }
	},
	components: { BaseExercise },
	data() {
		return {
			prettyQuiz: '',
			model: JSON.stringify(this.quizProp, undefined, 3),
			quiz: JSON.parse(JSON.stringify(this.quizProp)),
			quizKey: 0,
			quizModel: JSON.parse(JSON.stringify(this.quizProp))
		};
	},
	created() {
	},
	computed: {
		isValidQuiz () {
			return $functions.json.isJsonString(this.model) && this.quiz.isValid;
		},
		isJsonString() {
		    try {
		        JSON.parse(this.model);
		    } catch (e) {
		        return false;
		    }
		    return true;
		},
		errors() {
			let errors = [];
			if (this.quiz.solution.length < 5) {
				errors.push({text: 'Solution fill should have at least 5 characters', level: 'info'});
			} if (!this.quiz.isValid) {
				errors.push({text: 'You should specify <span class="text-info">one</span> operation with label <code>result</code>', level: 'danger'});
			}

			let messages = errors.length > 0 ? errors : [{text: 'Practice is complete', level: 'success'}];
			return $functions.tag('ul', messages.map(msg => $functions.tag('li', msg.text, {class: `text-${msg.level}`})));
		},
	},
	methods: {
		clearPractice() {
			this.quizModel = {};
		},
		restore() {
			this.quizModel = this.quiz.quiz;
		},
		save() {
			if (this.isValidQuiz) {
				this.$emit('quiz', JSON.parse(this.model));
			}
		},
		indent(event) {
			let start = event.target.selectionStart, begin = this.model.slice(0, start), end = this.model.slice(start), cursor = start + 3;
			this.model = begin + '   ' + end;
			event.target.focus();
			event.target.setSelectionRange(cursor, cursor);
			// log('indent from:', start, 'begin:', begin, 'end:', end, 'position:', cursor);
		}
	},
	watch: {
		model (value) {
			if (this.isJsonString) {
				let quiz = JSON.parse(value);
				this.prettyQuiz = $functions.json.prettyPrint(quiz);
				quiz = new Quiz(quiz, undefined, false);
				if (quiz.isValid) {
					this.quizKey += 1;
					this.quiz = quiz;
				}
			}
		},
		quizModel(value) {
			this.model = JSON.stringify(value, undefined, 3);
		}
	}
}